var map = {
	"./img-features-feature-2-game-1@2x.png": "UKY0",
	"./img-features-feature-2-game-2@2x.png": "Fv/Z",
	"./img-features-feature-2-game-3@2x.png": "e1wh",
	"./img-features-feature-2-game-4@2x.png": "FOl5",
	"./img-features-feature-2-game-5@2x.png": "8FXr",
	"./img-features-feature-2-game-6@2x.png": "iCGb",
	"./img-features-feature-2-game-7@2x.png": "ADv5",
	"./img-features-feature-2-game-8@2x.png": "jP7M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6+hB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features ^\.\/img\-features\-feature\-2\-game\-.*@2x\.png$
// module id = 6+hB
// module chunks = 18